import { Link } from "react-router-dom";
import styles from "./cards.module.scss";
import { Card } from "./cardSlice";
import { formatFullName } from "src/utils";
import { cardStatusMapping } from "src/components/constant/constant";
import { cardStatusColors } from "src/variable/randomColor";
import { ShortIdChip } from "src/components/UI/shortIdChip";
import {
  AccessTypePill,
  ApprovalNumber,
  cellClasses,
  DateStack,
  EmptyCell,
  MemberCell
} from "src/components/UI/transactionCells";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id: string) => <ShortIdChip id={id} copiedLabel="Card ID Copied!" fallback="---" />
  },
  {
    title: "Card No.",
    dataIndex: "cardNumber",
    key: "cardNumber",
    render: (_text: string, card: Card) => {
      const last4 = card?.cardNumber ? card.cardNumber.slice(-4) : null;
      const holderName =
        card?.cardHolderName ||
        formatFullName(card?.first_name, card?.last_name) ||
        formatFullName(card?.user?.firstName, card?.user?.lastName);

      if (!last4 && !holderName) return <EmptyCell />;

      return (
        <div className={cellClasses.tableWallet}>
          {holderName && <span className={cellClasses.tableWalletName}>{holderName}</span>}
          {last4 ? (
            <ApprovalNumber value={last4} masked />
          ) : (
            <span className={cellClasses.tableWalletDesc} style={{ fontStyle: "italic" }}>
              Card not issued
            </span>
          )}
        </div>
      );
    }
  },
  {
    title: "User",
    dataIndex: "id",
    key: "User",
    render: (_id: string, data: Card) => (
      <MemberCell
        fullName={formatFullName(data?.user?.firstName, data?.user?.lastName)}
        email={data?.user?.email}
        userId={data?.user?.id}
      />
    )
  },
  {
    title: "Site/Cost Centre",
    dataIndex: "object_id",
    key: "group",
    render: (object_id: string, data: Card) => {
      if (data?.object_type === "GROUP" && object_id) {
        return (
          <Link to={`/groups/${object_id}`} className={cellClasses.tableWalletName}>
            <ShortIdChip id={object_id} withCopy={false} withTooltip variant="ghost" />
          </Link>
        );
      }

      return <EmptyCell />;
    }
  },
  {
    title: "Status",
    dataIndex: "cardStatus",
    key: "cardStatus",
    render: (cardStatus: string) => (
      <div className={styles.tableCardStatus}>
        <div
          className={styles.tableCardStatusColor}
          style={{
            backgroundColor: `${cardStatusColors[cardStatus]}0d`,
            borderColor: `${cardStatusColors[cardStatus]}73`,
            color: `${cardStatusColors[cardStatus]}FF`
          }}
        >
          {cardStatusMapping[cardStatus]}
        </div>
      </div>
    )
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (created_at: string) => <DateStack value={created_at} />
  },
  {
    title: "Access Type",
    dataIndex: "accessType",
    key: "accessType",
    render: (accessType: string) => <AccessTypePill accessType={accessType} />
  }
];

export default columns;
